import { requestWithAuth } from "@/utils/authUtils";

const AdminDashboardService = {
  async getOverview(rangeDays) {
    let query = "";
    if (rangeDays === null) {
      query = "?range_days=all";
    } else if (typeof rangeDays === "number") {
      query = `?range_days=${rangeDays}`;
    }
    return requestWithAuth(`/admin/dashboard/overview${query}`, "GET");
  },
  async askQuestion(question) {
    return requestWithAuth("/admin/dashboard/ask", "POST", { question });
  },
};

export default AdminDashboardService;
